/* Magic Milk - Spar-Sets laufen von selbst weiter.

   Mert, 23.08.2026: "automatisches sliden" - zur Sektion SPAR-SETS.

   WIE: Das Theme baut die Reihe als eigenes Element <slideshow-component> mit
   den Pfeilen "Vorherige/Naechste Folie". Statt an dessen Innerem zu drehen,
   drueckt dieses Skript einfach alle paar Sekunden den Naechste-Knopf. Damit
   bleibt die ganze Logik des Themes zustaendig - Endlosschleife, Einrasten,
   Anzahl je Ansicht. Das ist auch der Grund, warum ein Theme-Update das hier
   nicht umwerfen kann.

   RUECKSICHT: Es laeuft nur, wenn die Reihe wirklich im Bild ist und das
   Fenster im Vordergrund steht. Wer die Maus darauf legt, wischt oder selbst
   auf einen Pfeil drueckt, haelt es an - beim Wischen dauerhaft, sonst nur
   solange die Maus daraufliegt. Niemandem wird die Ansicht unter dem Finger
   weggezogen. */
(function () {
  var TAKT = 4200;          /* Zeit zwischen zwei Schritten */
  /* 25.08.2026, Mert: "das auf die gesamte seite bei den betroffenen sections".
     Auf der Startseite stehen sechs Reihen mit Weiter-Pfeil, aber von drei
     verschiedenen Bausteinen - jeder mit eigener Knopf-Klasse. Statt sie
     einzeln aufzuzaehlen, wird nach dem Weiter-Knopf gesucht; das faengt auch
     kuenftige Reihen mit ein.
       slideshow-control--next   Theme (Spar-Sets)
       swiper-button-next        Sternify (Kollektions-Slider)
       *-btn-next-*              Section Store (Kollektion 5, Slider 2,
                                 Testimonials)
     NICHT dabei: die kleine Bildergalerie in einer Produktkarte und die
     Pfeile im Story-Fenster - beide gehoeren dem Nutzer, nicht der Seite. */
  var KNOEPFE = [
    '.slideshow-control--next',
    '.swiper-button-next',
    '[class*="-btn-next-"]'
  ].join(',');

  /* Diese bleiben aussen vor. */
  var TABU = 'product-card, .st_story-modal, #mmSEFenster, [class*="story-modal"]';

  var ruhig = false;
  try { ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function einrichten(komponente, name, knopf) {
    if (knopf) {
      if (knopf.dataset.mmAuto) return;
      knopf.dataset.mmAuto = '1';
    } else {
      if (komponente.dataset.mmAuto) return;
      komponente.dataset.mmAuto = '1';
    }

    var naechste = knopf || komponente.querySelector('.slideshow-control--next');
    if (!naechste) return;

    var imBild = false, maus = false, selbst = false, uhr = null;

    function darf() {
      return !ruhig && imBild && !maus && !selbst && !document.hidden;
    }
    function schritt() {
      if (!darf()) return;
      naechste.click();
    }
    function starten() {
      if (uhr) return;
      uhr = setInterval(schritt, TAKT);
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        imBild = e.some(function (x) { return x.isIntersecting; });
      }, { threshold: 0.35 }).observe(komponente);
    } else {
      imBild = true;
    }

    komponente.addEventListener('mouseenter', function () { maus = true; });
    komponente.addEventListener('mouseleave', function () { maus = false; });

    /* Wer selbst wischt oder klickt, will steuern - dann hoert das Skript auf. */
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (a) {
      komponente.addEventListener(a, function () {
        selbst = true;
        if (uhr) { clearInterval(uhr); uhr = null; }
      }, { passive: true });
    });

    starten();
  }

  function suchen() {
    var gefunden = 0;
    var knoepfe = document.querySelectorAll(KNOEPFE);
    for (var i = 0; i < knoepfe.length; i++) {
      var k = knoepfe[i];
      if (k.closest(TABU)) continue;
      /* Der Behaelter ist das, worauf Maus und Sichtbarkeit sich beziehen -
         die Sektion, in der der Knopf steckt. */
      var behaelter = k.closest('slideshow-component') ||
                      k.closest('.shopify-section') || k.parentElement;
      if (!behaelter) continue;
      einrichten(behaelter, behaelter.id || 'Reihe', k);
      gefunden++;
    }
    return gefunden > 0;
  }

  function versuchen() {
    if (suchen()) return;
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (suchen() || n > 25) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else {
    versuchen();
  }
  window.addEventListener('load', versuchen);
})();
